module.exports = __webpack_public_path__ + "assets/img/29_677_big.a9aecef5.jpg";